/* eslint-disable @typescript-eslint/no-unused-vars */
var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import styled from 'styled-components';
import { Divider, Heading, Image, Link, List, Text } from 'pcln-design-system';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS, INLINES, MARKS } from '@contentful/rich-text-types';
import ContentfulImage from '../ContentfulImage';
import ContentfulList from '../ContentfulList';
import { processText } from '../utils';
var Table = /*#__PURE__*/styled.table.withConfig({
  displayName: "ContentfulRichText__Table",
  componentId: "sc-1fwdgkk-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var TableRow = /*#__PURE__*/styled.tr.withConfig({
  displayName: "ContentfulRichText__TableRow",
  componentId: "sc-1fwdgkk-1"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var TableCell = /*#__PURE__*/styled.td.withConfig({
  displayName: "ContentfulRichText__TableCell",
  componentId: "sc-1fwdgkk-2"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n"], ["\n  display: flex;\n  width: 100%;\n"])));
var WrappingLink = /*#__PURE__*/styled(Link).withConfig({
  displayName: "ContentfulRichText__WrappingLink",
  componentId: "sc-1fwdgkk-3"
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  word-break: break-word;\n"], ["\n  word-break: break-word;\n"])));
var InlineImage = /*#__PURE__*/styled(Image).withConfig({
  displayName: "ContentfulRichText__InlineImage",
  componentId: "sc-1fwdgkk-4"
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: inline-block;\n"], ["\n  display: inline-block;\n"])));
var InlineContentfulImage = /*#__PURE__*/styled(ContentfulImage).withConfig({
  displayName: "ContentfulRichText__InlineContentfulImage",
  componentId: "sc-1fwdgkk-5"
})(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: inline-block;\n"], ["\n  display: inline-block;\n"])));
var getEmbeddedAsset = function (node, props) {
  var _a, _b;
  var assetProps = node.data.target;
  if ((_b = (_a = assetProps === null || assetProps === void 0 ? void 0 : assetProps.file) === null || _a === void 0 ? void 0 : _a.contentType) === null || _b === void 0 ? void 0 : _b.includes('image')) {
    var url = assetProps.file.url;
    return React.createElement(InlineImage, __assign({
      src: "https:".concat(url),
      mx: 1
    }, props));
  }
};
var getInlineEmbeddedEntry = function (node, props) {
  var entryProps = node.data.target;
  if ((entryProps === null || entryProps === void 0 ? void 0 : entryProps.contentTypeId) === 'image') {
    return React.createElement(InlineContentfulImage, __assign({}, entryProps, {
      mx: 1
    }, props));
  }
  if ((entryProps === null || entryProps === void 0 ? void 0 : entryProps.contentTypeId) === 'list') {
    return React.createElement(ContentfulList, __assign({}, entryProps, props));
  }
};
var Paragraph = function (_a) {
  var children = _a.children,
    props = __rest(_a, ["children"]);
  return React.createElement(Text.p, __assign({}, props), children);
};
var BoldText = function (_a) {
  var children = _a.children,
    props = __rest(_a, ["children"]);
  return React.createElement(Text.span, __assign({
    fontWeight: 'bold'
  }, props), children);
};
var ItalicText = function (_a) {
  var children = _a.children,
    props = __rest(_a, ["children"]);
  return React.createElement(Text.span, __assign({
    fontStyle: 'italic'
  }, props), children);
};
var LinkText = function (_a) {
  var children = _a.children,
    node = _a.node,
    props = __rest(_a, ["children", "node"]);
  var href = node.data.uri;
  var isRelativeLink = (href === null || href === void 0 ? void 0 : href.indexOf('#')) === 0 || (href === null || href === void 0 ? void 0 : href.indexOf('/')) === 0;
  return React.createElement(WrappingLink, __assign({
    target: isRelativeLink ? '_self' : '_blank',
    href: href
  }, props), children);
};
function getChildrenText(children) {
  var ATTEMPT_LIMIT = 10;
  var currChildren = children[0];
  var attempts = 1;
  var elementId = null;
  while (typeof currChildren === 'object' && Object.keys(currChildren).length !== 2 && attempts < ATTEMPT_LIMIT) {
    if (typeof currChildren.props === 'object') {
      currChildren = currChildren.props.children;
    }
    attempts++;
  }
  if (attempts < ATTEMPT_LIMIT && typeof currChildren === 'object') {
    elementId = currChildren[1];
  }
  return elementId;
}
function getMark(type, text, props) {
  switch (type) {
    case MARKS.BOLD:
      return React.createElement(BoldText, __assign({}, props), text);
    case MARKS.ITALIC:
      return React.createElement(ItalicText, __assign({}, props), text);
    case MARKS.SUBSCRIPT:
      return React.createElement("sub", null, React.createElement(Text.span, __assign({}, props), text));
    case MARKS.SUPERSCRIPT:
      return React.createElement("sup", null, React.createElement(Text.span, __assign({}, props), text));
  }
}
function isEmptyTrailingNode(node) {
  var _a, _b;
  var nodeContentValue = (_b = (_a = node === null || node === void 0 ? void 0 : node.content) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.value;
  return typeof nodeContentValue === 'string' && nodeContentValue === '' && node.content.length === 1;
}
function getNode(type, node, children, props) {
  var fontSize = props.fontSize,
    propsNoFontSize = __rest(props, ["fontSize"]);
  var color = props.color,
    propsNoColor = __rest(props, ["color"]);
  var textId = children ? getChildrenText(children) : null;
  var headingProps = __assign(__assign({}, propsNoFontSize), textId ? {
    id: textId
  } : {});
  if (type === 'hyperlink' && props.partnerUrl) {
    node.data.uri = node.data.uri.replaceAll(/{{{partnerUrl}}}/g, props.partnerUrl);
  }
  if (isEmptyTrailingNode(node)) {
    return;
  }
  switch (type) {
    case BLOCKS.HEADING_1:
      return React.createElement(Heading.h1, __assign({}, headingProps), children);
    case BLOCKS.HEADING_2:
      return React.createElement(Heading.h2, __assign({}, headingProps), children);
    case BLOCKS.HEADING_3:
      return React.createElement(Heading.h3, __assign({}, headingProps), children);
    case BLOCKS.HEADING_4:
      return React.createElement(Heading.h4, __assign({}, headingProps), children);
    case BLOCKS.HEADING_5:
      return React.createElement(Heading.h5, __assign({}, headingProps), children);
    case BLOCKS.HEADING_6:
      return React.createElement(Heading.h6, __assign({}, headingProps), children);
    case BLOCKS.PARAGRAPH:
      return React.createElement(Paragraph, __assign({}, props), children);
    case BLOCKS.HR:
      return React.createElement(Divider, __assign({}, props));
    case BLOCKS.UL_LIST:
      return React.createElement(List.ul, __assign({}, props), children);
    case BLOCKS.OL_LIST:
      return React.createElement(List.ol, __assign({}, props), children);
    case BLOCKS.TABLE:
      var TableNode = props.tableOverride || Table;
      return React.createElement(TableNode, __assign({}, props), children);
    case BLOCKS.TABLE_ROW:
      return React.createElement(TableRow, __assign({}, props), children);
    case BLOCKS.TABLE_CELL:
      return React.createElement(TableCell, __assign({}, props), children);
    case BLOCKS.EMBEDDED_ASSET:
      return getEmbeddedAsset(node, props);
    case INLINES.EMBEDDED_ENTRY:
      return getInlineEmbeddedEntry(node, props);
    case INLINES.HYPERLINK:
      return React.createElement(LinkText, __assign({}, propsNoColor, {
        node: node
      }), children);
  }
}
var options = function (props) {
  var _a, _b;
  return {
    renderText: function (text) {
      return processText(text, props);
    },
    renderMark: (_a = {}, _a[MARKS.BOLD] = function (text) {
      return getMark(MARKS.BOLD, text, props);
    }, _a[MARKS.ITALIC] = function (text) {
      return getMark(MARKS.ITALIC, text, props);
    }, _a[MARKS.SUBSCRIPT] = function (text) {
      return getMark(MARKS.SUBSCRIPT, text, props);
    }, _a[MARKS.SUPERSCRIPT] = function (text) {
      return getMark(MARKS.SUPERSCRIPT, text, props);
    }, _a),
    renderNode: (_b = {}, _b[BLOCKS.HEADING_1] = function (node, children) {
      return getNode(BLOCKS.HEADING_1, node, children, props);
    }, _b[BLOCKS.HEADING_2] = function (node, children) {
      return getNode(BLOCKS.HEADING_2, node, children, props);
    }, _b[BLOCKS.HEADING_3] = function (node, children) {
      return getNode(BLOCKS.HEADING_3, node, children, props);
    }, _b[BLOCKS.HEADING_4] = function (node, children) {
      return getNode(BLOCKS.HEADING_4, node, children, props);
    }, _b[BLOCKS.HEADING_5] = function (node, children) {
      return getNode(BLOCKS.HEADING_5, node, children, props);
    }, _b[BLOCKS.HEADING_6] = function (node, children) {
      return getNode(BLOCKS.HEADING_6, node, children, props);
    }, _b[BLOCKS.PARAGRAPH] = function (node, children) {
      return getNode(BLOCKS.PARAGRAPH, node, children, props);
    }, _b[BLOCKS.HR] = function () {
      return getNode(BLOCKS.HR, null, null, props);
    }, _b[BLOCKS.UL_LIST] = function (node, children) {
      return getNode(BLOCKS.UL_LIST, node, children, props);
    }, _b[BLOCKS.OL_LIST] = function (node, children) {
      return getNode(BLOCKS.OL_LIST, node, children, props);
    }, _b[BLOCKS.TABLE] = function (node, children) {
      return getNode(BLOCKS.TABLE, node, children, props);
    }, _b[BLOCKS.TABLE_ROW] = function (node, children) {
      return getNode(BLOCKS.TABLE_ROW, node, children, props);
    }, _b[BLOCKS.TABLE_CELL] = function (node, children) {
      return getNode(BLOCKS.TABLE_CELL, node, children, props);
    }, _b[BLOCKS.EMBEDDED_ASSET] = function (node, children) {
      return getNode(BLOCKS.EMBEDDED_ASSET, node, children, props);
    }, _b[INLINES.EMBEDDED_ENTRY] = function (node, children) {
      return getNode(INLINES.EMBEDDED_ENTRY, node, children, props);
    }, _b[INLINES.HYPERLINK] = function (node, children) {
      return getNode(INLINES.HYPERLINK, node, children, props);
    }, _b)
  };
};
/** @public */
function ContentfulRichText(_a) {
  var body = _a.body,
    props = __rest(_a, ["body"]);
  return React.createElement(React.Fragment, null, documentToReactComponents(body, options(props)));
}
export default ContentfulRichText;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;